import axios from 'axios';

export async function postEvets(data) {
    try {
        const URL = `${process.env.REACT_APP_NEW_CRM}/v1/event/register-event`;
        const response = await axios.post(URL, data);
        return response.data;
    } catch (error) {
        return { error };
    }
}

export async function postClassEvent(eventId) {
    try {
        const URL = `${process.env.REACT_APP_REPO}/v2/repo_aden/events/${eventId}/registrations`;
        const response = await axios.post(URL);
        return response.data;
    } catch (error) {
        return { error };
    }
}

export async function getInfoEvents(id) {
    const URL = `${process.env.REACT_APP_REPO}/v1/repo_aden/events/${id}`;

    try {
        const response = await axios.get(URL);
        return response.data.response_data;
    } catch (error) {
        return { error };
    }
}

export async function getDynamicEvents(modality, limit, timelapse, partnerId) {
    let URL = '';
    if (limit === 'all') {
        URL = `${process.env.REACT_APP_NEW_CRM}/v1/event?published=true&modality=${modality}&timelapse=${timelapse}&partner_id=${partnerId}`;
    } else {
        URL = `${process.env.REACT_APP_NEW_CRM}/v1/event?published=true&modality=${modality}&limit=${limit}&timelapse=${timelapse}&partner_id=${partnerId}`;
    }
    if (URL !== '') {
        try {
            const response = await axios.get(URL);
            return response.data;
        } catch (error) {
            return { error };
        }
    }
}

export async function getDynamicClasses(modality, limit, timelapse) {
    let URL = '';
    if (limit === 'all') {
        URL = `${process.env.REACT_APP_REPO}/v2/repo_aden/events?is_online=${modality}&timelapse=${timelapse}`;
    } else {
        URL = `${process.env.REACT_APP_REPO}/v2/repo_aden/events?is_online=${modality}&limit=${limit}&timelapse=${timelapse}`;
    }

    if (URL !== '') {
        try {
            const response = await axios.get(URL);
            return response.data;
        } catch (error) {
            return { error };
        }
    }
}

export async function patchUnregisterClassEvent(eventId, body) {
    try {
        const URL = `${process.env.REACT_APP_REPO}/v2/repo_aden/events/${eventId}/registrations`;
        const response = await axios.patch(URL, body);
        return response.data;
    } catch (error) {
        return { error };
    }
}

export async function getCycles() {
    const URL = `${process.env.REACT_APP_REPO}/v2/repo_aden/events/cycles`;
    try {
        const response = await axios.get(URL);
        return response.data;
    } catch (error) {
        return { error };
    }
}
